module.exports = __webpack_public_path__ + "static/media/sampleAreaMarker.550ad490.jpeg";